import { z } from 'zod/v4';

export const gateSchema = z.object({
  id: z.number(),
  type: z.enum(['Two Way', 'Entry', 'Exit']),
  vehAllowed: z.array(z.string()),
  gateToSite: z.object({
    coordinates: z.object({
      type: z.literal('Point'),
      coordinates: z.array(z.number()),
    }),
  }),
  gateToRoad: z.object({
    coordinates: z.object({
      type: z.literal('Point'),
      coordinates: z.array(z.number()),
    }),
  }),
});

export type Gate = z.infer<typeof gateSchema>;
